const homeCardsData = [
    {
        id: 1,
        title: "Comedy",
        link: "/movies/comedy"
    },
    {
        id: 2,
        title: "Action",
        link: "/movies/action"
    },
    {
        id: 3,
        title: "Family",
        link: "/movies/family"
    },
    {
        id: 4,
        title: "Sci-Fi",
        link: "/movies/science-fiction"
    },
    {
        id: 5,
        title: "Drama",
        link: "/movies/drama"
    },
    {
        id: 6,
        title: "Popular",
        link: "/movies/popular-movies"
    },
]

export default homeCardsData